<script>
import VimeoPlayerOptimized from './VimeoPlayerOptimized'
export default {
  name: 'VimeoPlayerWithControls',
  components: {
    VimeoPlayerOptimized
  },
  props: {
    item: {
      type: Object,
      required: true
    },
    hideCaptions: {
      type: Boolean,
      default: false
    },
    collapseCaption: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    paused: true,
    muted: true,
    timeupdate: null,
    isReady: false
  }),

  computed: {
    videoPlaybackCountDown () {
      if (!this.timeupdate) return ''
      const toTimeCode = timeSec => {
        const sec = parseInt(Math.abs(timeSec), 10)
        let hours = Math.floor(sec / 3600)
        let minutes = Math.floor((sec - (hours * 3600)) / 60)
        let seconds = sec - (hours * 3600) - (minutes * 60)

        if (hours > 0 && hours < 10) { hours = '0' + hours }
        if (minutes < 10) { minutes = '0' + minutes }
        if (seconds < 10) { seconds = '0' + seconds }
        return (hours > 0 ? `${hours}:` : '') + minutes + ':' + seconds
      }
      const remained = this.timeupdate.seconds - this.timeupdate.duration
      return (remained < 0 ? '-' : '') + toTimeCode(remained)
    }
  },

  watch: {
    item () {
      this.isReady = false
    }
  },

  methods: {
    toggleVimeoPlay () {
      if (this.$refs['vimeo-player']) {
        this.$refs['vimeo-player'].togglePlay()
      }
    },

    toggleVimeoSound () {
      if (this.$refs['vimeo-player']) {
        this.$refs['vimeo-player'].toggleSound()
      }
    },

    onPausedChange (paused) {
      this.paused = paused
      this.$emit('paused', paused)
    },

    onMutedChange (muted) {
      this.muted = muted
      this.$emit('muted', muted)
    },

    onTimeUpdate (timeData) {
      this.timeupdate = timeData
      this.$emit('timeupdate', timeData)
    },

    onProgress (progressData) {
      this.$emit('progress', progressData)
    },

    onReady () {
      this.isReady = true
      this.$emit('ready')
    }
  }
}
</script>
<template>
  <figure class="vimeo-player-with-controls">
    <VimeoPlayerOptimized
      ref="vimeo-player"
      :value="item"
      class="relative"
      @paused="onPausedChange"
      @muted="onMutedChange"
      @timeupdate="onTimeUpdate"
      @progress="onProgress"
      @ready="onReady" />
    <div class="attachment-footer">
      <figcaption v-if="item.caption && item.caption.trim()" class="caption text-xs">
        {{ item.caption.trim() }}
      </figcaption>
      <div
        class="video-controls flex items-center">
        <div class="font-mono text-xs whitespace-no-wrap opacity-80 ml-base mr-base">
          {{ videoPlaybackCountDown }}
        </div>
        <button class="compact" :class="!isReady ? ['spin', 'active'] : []" @click="toggleVimeoPlay" :title="paused ? 'Play' : 'Pause'">
          <span class="material-icons">
            {{ paused ? 'play_arrow' : 'pause' }}
          </span>
        </button>
        <button class="compact" @click="toggleVimeoSound" :title="muted ? 'Unmute' : 'Mute'">
          <span class="material-icons">
            {{ muted ? 'volume_off' : 'volume_up' }}
          </span>
        </button>
      </div>
    </div>
  </figure>
</template>

<style scoped lang="scss">
button {
  width: var(--base-size);
  height: var(--base-size);
}
.attachment-footer {
  display: flex;
  grid-gap: var(--small-padding);
  gap: var(--small-padding);

  @media (max-width: 600px) {
    flex-direction: column-reverse;
    grid-gap: 0;
    gap: 0;
    .caption {
      padding-top: 0;
    }
  }

  figcaption {
    position: relative;
  }
  .video-controls {
    background: var(--color-bg-semitransparent);
    background: color-mix(in srgb, var(--color-bg) 40%, transparent);
    backdrop-filter: blur(5px);
    height: var(--base-size);
    margin-left: auto;
    transition: scale 0.2s ease-in-out;

    button.spin {
      animation: spin 0.5s linear infinite;
      .material-icons {
        transform: scale(1.2);
      }
    }
  }
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
</style>
